import gql from 'graphql-tag';

export const OBSERVATIONS_SAFETY_DASHBOARD_QUERY = gql`
  query ObservationsSafetyDashboard($first: Int, $after: String, $filter: ObservationFilter) {
    observations(first: $first, after: $after, filter: $filter) {
      id
      type
      cursor
      answers {
        id
        processedOn
      }
    }
  }
`;
